// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1xokt","footer":"ReportModalFilter_footer__1HCbW"};